export class Task {
  Id: number;
  RecordId: number;
  CreatedBy: number;
  CreatedDate: string;
  EndDate: Date;
  IsActive: boolean;
  IsAPN: boolean;
  IsArchived: boolean;
  IsCommunity: boolean;
  IsDeleted: boolean;
  ModifiedBy: number;
  ModifiedDate: string;
  Name: string;
  Number: string;
  ProjectId: number;
  StartDate: Date;
  TlinxChargeableFlag: boolean | null;

  constructor(obj?: Partial<Task>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  get NameAndNumber(): string {
    return this.Name + ' (' + this.Number + ')';
  }
}
